import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Contact } from '../../../models/contact';
import { Observable, Subject, Subscription } from 'rxjs';
import { Card } from '../../../models/card';
import { ContactService } from '../../../data/contact.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectContactSaving } from '../../../store/contacts-table/contacts-table.state';
import { contactSaveRequest } from '../../../store/contacts-table/contacts-table.actions';
import { AddressBookService } from '../../../data/address-book.service';
import { emptyContact } from '../../../constants/empty-contact';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { CardFormComponent } from '../../shared/card-form/card-form.component';
import { MatOption } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { CardTypeEnum } from '../../../enum/card-type.enum';
import {
    selectContactEditorId,
    selectContactEditorLoading, selectContactEditorSaving,
    selectContactEditorState
} from '../../../store/contact-editor/contact-editor.state';
import { map, take, tap } from 'rxjs/operators';
import {
    contactEditorSaveRequest,
    contactEditorSetAddressBookId,
    contactEditorSetReference
} from '../../../store/contact-editor/contact-editor.actions';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-contact-edit',
    templateUrl: './contact-edit.component.html',
    styleUrls: [ './contact-edit.component.scss' ],
    imports: [MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatOption, CardFormComponent, MatInput, MatAnchor, IconComponent, AsyncPipe, MatProgressSpinner, MatDialogContent, MatDialogActions, MatButton]
})
export class ContactEditComponent implements OnInit, OnDestroy {

    public contact: Contact;
    public card$: Observable<Card>;
    public cardSubject: Subject<Card>;
    public cardTypes = CardTypeEnum;

    public reference = new FormControl('');
    public addressBook = new FormControl('');
    public contactForm = new FormGroup({
        addressBook: this.addressBook,
        reference: this.reference
    });

    constructor(private dialogRef: MatDialogRef<ContactEditComponent>,
                private contactService: ContactService, private snackbar: MatSnackBar, private store: Store<AppState>,
                private addressBookService: AddressBookService) {
        this.cardSubject = new Subject();
        this.card$ = this.cardSubject.asObservable();
    }

    public addressBooks$ = this.addressBookService.all().pipe(
        tap(list => console.log(list))
    );
    public showAddressBook$ = this.store.select(selectContactEditorId).pipe(
        map(id => id === null)
    );
    public saving$ = this.store.select(selectContactEditorSaving);
    public loading$ = this.store.select(selectContactEditorLoading);
    public disableSave$ = this.store.select(selectContactEditorState).pipe(
        map(state => state.saving
            || (state.id === null && state.addressBookId === null)
            || state.card.country === ''
            || state.card.country === '')
    );

    private stateSubscription: Subscription;

    ngOnInit(): void {
        this.stateSubscription = this.store.select(selectContactEditorState).subscribe((state) => {
            this.addressBook.setValue(state.addressBookId);
            this.reference.setValue(state.reference);
        });
    }

    ngOnDestroy(): void {
        this.stateSubscription.unsubscribe();
    }

    save(): void {
        this.store.dispatch(contactEditorSetReference({ reference: this.reference.value }));
        this.store.dispatch(contactEditorSetAddressBookId({ addressBookId: this.addressBook.value }));
        this.store.dispatch(contactEditorSaveRequest());
    }

    changeAddressBook(id?: string): void {
        this.store.dispatch(contactEditorSetAddressBookId({ addressBookId: id }));
    }

    changeReference(): void {
        this.store.dispatch(contactEditorSetReference({ reference: this.reference.value }));
    }

    cancel(): void {
        this.dialogRef.close(null);
    }

}
